
import { Component, OnInit } from '@angular/core';
import { ContractDto } from 'src/app/models/contractDto';
import { ContractsService } from 'src/app/services/contracts.service';
import { NotificationService } from 'src/app/services/notification.service';
import { NotificationType } from 'src/app/models/notification.message';
import { approveContractVm } from 'src/app/models/approveContractVm';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TokenService } from 'src/app/services/token.service';
import { RequestApprovalDto } from 'src/app/models/requestapproval-dto';
import { RequestApprovalsService } from 'src/app/services/requestapprovals.service';
import { ManPowersService } from 'src/app/services/man-powers.service';
import { ManPowerDto } from 'src/app/models/ManPowerDto';
import { approveManPowerVm } from 'src/app/models/approveManPowerVm';
import { ManpowerapprovalService } from 'src/app/services/manpowerapproval.service';
import { ManpowerJDDto } from 'src/app/models/requests/ManpowerJDDto';
import * as FileSaver from 'file-saver';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-view-approvemanpower',
  templateUrl: './view-approvemanpower.component.html',
  styleUrls: ['./view-approvemanpower.component.css']
})
export class ViewApprovemanpowerComponent implements OnInit {

  ViewManPowerVisible = false;
  ViewlevelOfCompliance = false;
  ApproveRequest: ManPowerDto | any
  ManPowerApprovals: RequestApprovalDto[] | undefined;
  currentUser: any;
  PathReportString:string="";
  pdf:string="";
  thecontent:string="";
  isManPowerpprovalModalVisible = false
  isFileDocument = false
  showCreatedByColumn: boolean = false;
  showFunctionColumn: boolean = false;
  ManPowerJD: ManpowerJDDto[] | undefined;
 LevelOfCompliance = [
  
  {  compliance: "HIGH"},
  {  compliance: "LOW"},
  { compliance: "MEDIUM"},
 
];
  constructor(private manPowerService: ManPowersService, private sanitizer: DomSanitizer, private notification: NotificationService,
    private tokenService: TokenService, private manpowerApprovalService:ManpowerapprovalService  ) { }

  ManPower: ManPowerDto[] | any;
  Comment: string = '';
  aprovedDepartmentManpowerFigure: number = 0 
  presentDepartmentManpowerFigure: number = 0
  LevelOfExposureCompliance: string = ''
  receivedfile: string = ''
  ngOnInit(): void {
    this.loadRecords();
  }

  async loadRecords() {
    
    ;
    let resManPower = await this.manPowerService.getPendingManPower().toPromise();
    this.ManPower = <ManPowerDto[]>resManPower.responseData;
;
    if ((this.ManPower[0].createdBy == this.currentUser.profile.email)) { this.isManPowerpprovalModalVisible = true; }
   
  
    
    // let model = payload.movementRequest;
    // this.contract=model;

    // this.thecontent = model.additionalDocument.documentContent;
    // this.thecontent=this.thecontent.substring(28);
    // this.pdf = model.additionalDocument.documentContent;
    
    // this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.thecontent) as any).changingThisBreaksApplicationSecurity;
          
    // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
    
  
  }

  async open(datas: ManPowerDto) {
    this.ViewManPowerVisible = true;
;

this.currentUser = this.tokenService.getInfo(); 
    this.ApproveRequest = datas;

    let resApprovals = await this.manpowerApprovalService.getRequestApprovals(datas.id).toPromise();
    this.ManPowerApprovals = <RequestApprovalDto[]>resApprovals.responseData;

     if ((this.currentUser.profile.email == 'gbemiga.owolabi@ng.huaxin.com' || this.currentUser.profile.email == 'lolu.akinyemi@ng.huaxin.com')) { this.ViewlevelOfCompliance = true; }
   
    
   
  }
 
  async showDocument(datas: ManPowerDto){
  // this.open();
  ;
  let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
     ;
   
     this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;
   
      this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
      this.pdf = getJDRequest.responseData[0].documentContent
   
     // this.PathReportString = 'data:application/pdf;base64,' + (this.sanitizer.bypassSecurityTrustResourceUrl(this.receivedfile) as any).changingThisBreaksApplicationSecurity;
            
     // top!.document.getElementById('ifrm')!.setAttribute("src", this.PathReportString)!;
     const pdfWindow = window.open("")!;    
     pdfWindow.document.write("<html<head><title>Additional Report</title><style>body{margin: 0px;}iframe{border-width: 0px;}</style></head>");    
     pdfWindow.document.write("<body><embed width='100%' height='100%' src='data:application/pdf;base64, " +    
     encodeURI(this.receivedfile) + "#toolbar=0&navpanes=0&scrollbar=0'></embed></body></html>") 
 
 
 }

  
  handleCancel(): void {
    this.isManPowerpprovalModalVisible = false;
   
  }
  async approveManPower() {
   // this.isManPowerpprovalModalVisible = true;
   ;
   
    this.currentUser = this.tokenService.getInfo();
;
    if ((this.currentUser.profile.email == this.ApproveRequest.hrbpToApprove && this.ApproveRequest.hrbpToApprove == 'Pending'))  {  this.isManPowerpprovalModalVisible = true;  return }
    
    
      ; 
      const model: approveManPowerVm = { id: this.ApproveRequest.id, LevelOfExposureCompliance: this.LevelOfExposureCompliance, message: this.Comment, aprovedDepartmentManpowerFigure: this.aprovedDepartmentManpowerFigure, presentDepartmentManpowerFigure: this.presentDepartmentManpowerFigure };
      
       this.manPowerService.approveManPower(model).subscribe({
         next: (data => {
           
           if (data.responseCode == "00") {
             this.notification.sendMessage({
               message: data.message,
               type: NotificationType.success
             });

             this.loadRecords();
             this.close()
           }
           else {

             this.notification.sendMessage({
             message: data.message,
               type: NotificationType.error
             });

           }

         }),
         error: ((error: any) => {
           console.log(error.error);
           ;


           this.notification.sendMessage({
             message: error.error.message,
             type: NotificationType.error
           });
         })

       });

  }

  async sendManPowerApproval() {
    this.currentUser = this.tokenService.getInfo();

      ; 
      const model: approveManPowerVm = { id: this.ApproveRequest.id, LevelOfExposureCompliance: this.LevelOfExposureCompliance, message: this.Comment, aprovedDepartmentManpowerFigure: this.aprovedDepartmentManpowerFigure, presentDepartmentManpowerFigure: this.presentDepartmentManpowerFigure };
      
      this.manPowerService.approveManPower(model).subscribe({
        next: (data => {
          
          if (data.responseCode == "00") {
            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.success
            });

            this.loadRecords();
            this.isManPowerpprovalModalVisible = false;
            this.close()
            
          }
          else {

            this.notification.sendMessage({
              message: data.message,
              type: NotificationType.error
            });

          }

        }),
        error: ((error: any) => {
          console.log(error.error);
          ;


          this.notification.sendMessage({
            message: error.error.message,
            type: NotificationType.error
          });
        })

      });

  }

  
  async getJD(datas: ManPowerDto) {
    // this.ViewManPowerVisible = true;
 ;
     this.ApproveRequest = datas;
     let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
     ;
   
     this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;

      this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
      const b = Uint8Array.from(atob(this.receivedfile), c => c.charCodeAt(0));
      const blob = new Blob([b] , {type: "application/octet-stream"});
      FileSaver.saveAs(blob, getJDRequest.responseData[0].documentName);
   } 
   
//   async viewJD(datas: ManPowerDto) {
//     // this.ViewManPowerVisible = true;
//  ;
//      this.ApproveRequest = datas;
//      let getJDRequest = await this.manPowerService.GetJDForRequest(datas.id).toPromise();
//      ;
   
//      this.ManPowerJD = <ManpowerJDDto[]>getJDRequest.responseData;

//      this.receivedfile = getJDRequest.responseData[0].documentContent.replace("data:application/pdf;base64," , "")
//      const b = Uint8Array.from(atob(this.receivedfile), c => c.charCodeAt(0));
//      const blob = new Blob([b] , {type: "application/pdf"});
    
//     //  const source = `data:application/pdf;base64,${base64String}`;
  
//    }
   

  async rejectManPower() {

    if (this.Comment === '') {
      this.notification.sendMessage({
        message: 'Comment is required when rejecting Man Power request',
        type: NotificationType.error
      });
    }
    else {
      

        this.close();

        const model: approveManPowerVm = { id: this.ApproveRequest.id, LevelOfExposureCompliance: this.LevelOfExposureCompliance, message: this.Comment, aprovedDepartmentManpowerFigure: this.aprovedDepartmentManpowerFigure, presentDepartmentManpowerFigure: this.presentDepartmentManpowerFigure  };

        this.manPowerService.rejectManPower(model).subscribe({
          next: (data => {

            if (data.responseCode == "00") {
              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.success
              });

              this.loadRecords();
              this.close();
            }
            else {

              this.notification.sendMessage({
                message: data.message,
                type: NotificationType.error
              });

            }

          }),
          error: ((error: any) => {
            console.log(error.error);
            ;


            this.notification.sendMessage({
              message: error.error.message,
              type: NotificationType.error
            });
          })

        });
    
    }
  }



  getColor(status: string): string { 
    switch (status) {
      case "MEDIUM":
        return 'badge badge-warning';
      case "LOW":
        return 'badge badge-success';
      case "HIGH":
        return 'badge badge-danger';
      default:
        return 'badge badge-info';
    }

  }

  close(): void {
    this.ViewManPowerVisible = false;
  }

  cancel(): void {
 return;
  }
 
  confirm(): void {
    alert('click confirm');
  }



}
